export const api = {
  GET_USER_ROLE : '/index.php?r=api/v1/user/user/list-role',
  BULK_SWITCH_PIC : '/index.php?r=api/v1/change_pic/pic/update',
  BULK_SWITCH_STATUS: '/index.php?r=api/v1/change_pic/pic/status-change'
};

export const handleFailedBulk = (ctx, intervalId) => {
  if (intervalId){
    clearInterval(intervalId);
  }
  ctx.commit('setProgressTitle', 'Process Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  setTimeout(() => {
    ctx.commit('setShowProgressBar', false);

  }, 2000);
  ctx.commit('setLoadingPic', false);
};

export const handleUpdateProcess = (ctx) => {
  ctx.commit('setLoadingPic', true);
  ctx.commit('setShowProgressBar', true);
  ctx.commit('setLoading', true);
  ctx.commit('setPercentage', 0);
  ctx.commit('setProgressTitle', 'Changing PIC');
  ctx.commit('setProgressColor', 'green');
};

export const handleStatusSuccess = (ctx) => {
  
  ctx.commit('setIntervalSwitch', null);
  ctx.commit('setPercentage', 100);
  ctx.commit('setProgressTitle', 'Switch Done');
  setTimeout(() => {
    ctx.commit('setShowProgressBar', false);
    
  }, 2000);
};